import {useTranslation} from '@aboutyou/i18n';
import type {TransitionComponentType} from '@aboutyou/transitions';
import {styled} from '@linaria/react';
import React from 'react';
import {
  mediaMobileOnly,
  mobileOnlyLinaria,
} from '../../../constants/customMedia';
import {AboutNameLogo} from './AdditionalLogos/AboutNameLogo/AboutNameLogo';
import {SpecialLogo, SpecialLogoOptions} from './AdditionalLogos/SpecialLogo';

interface AboutYouLogoOptions {
  id?: string;
  firstName?: string;
  firstNameMaxLength?: number;
  disableSvgLogo: boolean;
  className?: string;
  testId?: string;
  disableLogoLink?: boolean;
  FirstNameAnimationComponent?: TransitionComponentType;
  showAYAnniversaryCampaign?: boolean;
  showHeartIcon?: boolean;
  trackOriginClickFunction?: VoidFunction;
}

type AboutYouLogoProps = SpecialLogoOptions & AboutYouLogoOptions;

export const AboutYouMainLogo: React.FC<AboutYouLogoProps> = ({
  firstName,
  firstNameMaxLength,
  isVip,
  woohooCampaign,
  disableSvgLogo,
  BASCampaignHeaderLogoComponent,
  className,
  testId,
  FirstNameAnimationComponent,
  disableLogoLink,
  showAYAnniversaryCampaign,
  showHeartIcon,
  trackOriginClickFunction,
  ...props
}) => {
  const {t} = useTranslation();

  return (
    <Wrapper
      data-testid={testId ?? 'headerLogo'}
      aria-label={t('Start page')}
      className={className}
    >
      <StyledAboutNameLogo
        firstName={firstName}
        firstNameMaxLength={firstNameMaxLength}
        disableSvgLogo={disableSvgLogo}
        FirstNameAnimationComponent={FirstNameAnimationComponent}
        trackOriginClickFunction={trackOriginClickFunction}
        disableLogoLink={disableLogoLink}
        showAYAnniversaryCampaign={showAYAnniversaryCampaign}
        showHeartIcon={showHeartIcon}
      />
      <StyledSpecialLogo
        $reducedSize={Boolean(isVip && showAYAnniversaryCampaign)}
        isVip={isVip}
        woohooCampaign={woohooCampaign}
        BASCampaignHeaderLogoComponent={BASCampaignHeaderLogoComponent}
        {...props}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 35px;
  padding: 0px 5px 0px 4px;
  direction: initial;

  ${mobileOnlyLinaria('flex-grow: 1;')}
`;

const StyledAboutNameLogo = styled(AboutNameLogo)`
  margin-right: 1px;

  [dir='rtl'] & {
    margin-left: 1px;
    margin-right: unset;
  }
`;

const StyledSpecialLogo = styled(SpecialLogo)<{$reducedSize: boolean}>`
  @media ${mediaMobileOnly} {
    svg {
      width: ${props => (props.$reducedSize ? '22px' : 'max-content')};
    }
  }
`;
